import { RUNNER_LANE_MAX, RUNNER_SHOW_HITBOX } from '../../../../domain/runner/runnerConstants';
import { computeRunnerPlayerHitbox } from '../../../../domain/runner/runnerPlayerHitbox';
import type { RunnerLevel, RunnerPlayer } from '../../../../domain/runner/runnerTypes';
import { LEVEL_GAMEPLAY_Z_INDEX } from './gameplayConstants';
import type { LevelCanvasLayout } from './layout/runnerLevelLayout';
import { projectSvgPointInWorld } from './layout/runnerLevelLayout';
import './LevelHitboxOverlay.css';

type LevelHitboxOverlayProps = {
  level: RunnerLevel;
  player: RunnerPlayer;
  layout: LevelCanvasLayout;
};

export function LevelHitboxOverlay({ level, player, layout }: LevelHitboxOverlayProps) {
  if (!RUNNER_SHOW_HITBOX) {
    return null;
  }

  const hitbox = computeRunnerPlayerHitbox(level, player);
  const svgX = level.startPointSvgX + hitbox.centerS;
  const svgY = (RUNNER_LANE_MAX - hitbox.centerLane) * level.viewBox.height;
  const { leftPx, topPx } = projectSvgPointInWorld(svgX, svgY, layout);
  const widthPx = hitbox.widthS * layout.displayScale;
  const heightPx = hitbox.heightLane * level.viewBox.height * layout.displayScale;

  return (
    <div
      className="level-hitbox-overlay__box level-hitbox-overlay__box--player"
      style={{
        left: leftPx,
        top: topPx,
        width: widthPx,
        height: heightPx,
        zIndex: LEVEL_GAMEPLAY_Z_INDEX.DEBUG_HITBOX,
      }}
    />
  );
}
